module.exports = __webpack_public_path__ + "static/img/src_pic.8816331.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/src_pic.png
// module id = y5+3
// module chunks = 0